import { Component, OnInit, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser'
import { RouterModule, Routes } from '@angular/router';
import { AbstractComponent } from '../util/abstract.component';
import { SessaoService } from '../services/sessao.service';

import { MenuComponent } from '../menu/menu.component';
import { HeaderComponent } from '../header/header.component';

import { SegundaViaModalBoletoComponent } from '../bf-segundavia-cli/segundavia-modal-boleto.component';
import { EnderecoModalBuscaComponent } from '../bf-endereco-cli/endereco-modal-busca.component';
import { EnderecoModalConfirmarComponent } from '../bf-endereco-cli/endereco-modal-confirmar.component';
import { SegundaViaCarneModalEnderecoComponent } from '../bf-segundaviacarne-cli/segundaviacarne-modal-endereco.component';

declare var $ :any;

@Component({
  selector: 'app-bf-portal',
  templateUrl: './bf-portal.component.html',
  styleUrls: ['./bf-portal.component.css']
})

export class BfPortalComponent extends AbstractComponent implements OnInit {

  constructor(private sessaoService: SessaoService) {
    super(sessaoService);
  }

  ngOnInit() {

    // Menu
    $("#menu-toggle").click(function(e) {
      e.preventDefault();
      $(".page").toggleClass("toggled");
      //Tabs
      setTimeout(function(){
        $('ul.tabs').tabs();
      }, 600);
    });

    // Modal
    $('.modal').modal();

    //Tabs
    $('ul.tabs').tabs();

    // Exibe modal primeiro acesso
    if(sessionStorage.getItem("modalPrimeiroAcessoCampanha") == "true"){
      if(this.sessaoService.sessao.configuracaoVisual.cdIndcdCampanha ||
        this.sessaoService.sessao.configuracaoVisual.cdIndcdPrimeiroAcesso){
          this.modalPrimeiroAcesso();
      }
    }
  }

  modalPrimeiroAcesso(){
    $('#m-primeiro-acesso').modal('open');
  }

}



// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/bf-portal/bf-portal.component.ts